import {debounce} from '@helpers/utils'
import {Component} from 'lowkey-component'

import type {IField} from './BaseFormField'
import {BaseFormField} from './BaseFormField'

export class FormInputField extends BaseFormField implements IField {
  private input: Component<HTMLInputElement> | null =
    null

  didMount() {
    super.didMount()
    this.input = new Component<HTMLInputElement>(this.element?.querySelector('input') as HTMLInputElement)
    this.input.mount()
    this.input.on('blur', this.onBlur.bind(this))
    this.input.on('keyup', debounce(this.onChange.bind(this), 200))
  }

  set readonly(val: boolean) {
    if (val) {
      this.input?.element?.setAttribute('readOnly', 'true')
    } else {
      this.input?.element?.removeAttribute('readOnly')
    }
  }

  get value(): string {
    return this.input?.element?.value || ''
  }

  get name() {
    return this.input?.element?.getAttribute('name') || ''
  }
}
